import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { SpecialKeyValComboBox, createGroups } from "../../SFRTA/TrackDisturbanceReport";
import { Col, Row } from "reactstrap";

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { location, subdivision, user, date, formSummary, isMaintenance } = reportData;
  if (!formSummary) formSummary = {};
  
  let data = {
    lineName: subdivision,
    location: location,
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };

  let reportTitle=reportData.isMaintenance ? "MR Number" : "Title"

  let formValue=reportData.isMaintenance ?  reportData.formSummary && reportData.formSummary.formId ? reportData.formSummary.formId : null : "N/A"

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection
        title="Change In Curve Report"
        {...props}
        centerTitle={true}
        fontSizeOverride="24px"
        isMaintenance={isMaintenance}
      />
      <ReportInfoSection
        centered={true}
        fontSizeOverride="20px"
        titleWidthOverride={{
          col1: "150px",
          col2: "100px",
        }}
        rows={[
          {
            col1: {
              title:reportTitle ,
              value: reportData.title,
            },
            col2: {
              title: "Form ID",
              value: formValue,
            },
          },

          {
            col1: {
              title: "Subdivision",
              value: data.lineName,
            },
            col2: {
              title: "Mileage",
              value: data.mileage,
            },
          },
          {
            col1: {
              title: "Submitted By",
              value: data.user,
            },
            col2: {
              title: "Date",
              value: data.reportDate,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <Row>
        <Col md={2}></Col>
        <Col md={8}>
          <SpecialKeyValComboBox
            data={data}
            titleAlign={"left"}
            style={{ fontSize: "20px", width: "100%" }}
            rows={createGroups(
              [
                { title: "North Spiral (feet)", valId: "nort" },
                { title: "Body of Curve (feet)", valId: "boc" },
                { title: "South Spiral (feet)", valId: "sout" },
                { title: "Degree of Curve (degrees : minutes)", valId: "doc" },
                { title: "Superelevation (inches)", valId: "super" },
              ],
              1,
            ).map((row) => ({ columns: row.map((property) => ({ ...property, titleColSpan: 7, valueColSpan: 3 })) }))}
          />
        </Col>
        <Col md={2}></Col>
      </Row>
    </div>
  );
};

const ONR_ChangeInCurveReport = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;
  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["onr_m_changeInCurveForm"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["onr_i_changeInCurveForm"]);

  const additionalReportParams = {
    location: isMaintenance ? ReportGeneratorUtils.getMaintenanceLocation(inspec) : ReportGeneratorUtils.getInspectionLocation(inspec),
    subdivision: isMaintenance
      ? ReportGeneratorUtils.getMaintenanceSubdivision(inspec)
      : ReportGeneratorUtils.getInspectionSubdivision(inspec),
    date: ReportGeneratorUtils.getInspectionDate(inspec),
    user: ReportGeneratorUtils.getInspectionUser(inspec),
    isMaintenance: isMaintenance,
  };

  return formSummaries.map((summary, _i) => (
    <ReportView
      key={_i}
      {...props}
      reportData={{
        title: title,
        formSummary: summary,
        ...additionalReportParams,
      }}
    />
  ));
};

export default ONR_ChangeInCurveReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/ChangeInCurveReport/index.jsx